module.exports = __webpack_public_path__ + "img/38_71.fec59f8b.png";